// extracted by mini-css-extract-plugin
export var callout = "callouts-module--callout--3f846";
export var callout_link = "callouts-module--callout_link--fb48a";
export var callouts = "callouts-module--callouts--9c505";
export var pdp_callouts = "callouts-module--pdp_callouts--fdcac";